import { Avatar } from "@uzverse/ui";
import { useTranslation } from "react-i18next";
import { useAssistant } from "../state/assistant.js";
import { AvatarPortrait } from "../world/humans/AvatarPortrait.js";
import { decodeAppearance } from "../world/humans/spec.js";

/** The assistant's 3D portrait (its `appearance` setting), or its initials until settings load. */
export function AssistantPortrait({ animate = false }: { animate?: boolean }) {
  const { t } = useTranslation("web");
  const { settings } = useAssistant();
  if (!settings) return <Avatar name="…" assistant size={52} />;
  return (
    <AvatarPortrait
      spec={decodeAppearance(settings.appearance, settings.name)}
      label={t("avatar.portrait", { name: settings.name })}
      framing="bust"
      animate={animate}
    />
  );
}
